<template>
  <section class="cx-t02 -fade -border-top" :class="{'m-breadcrumb': isArticle}">
    <div :class="warpperClass">
      <div class="cx-row--line m-breadcrumb__row">
        <div v-if="updatedAt" class="m-update">
          {{$t('common.updatedAt', {
            date: $options.filters.timestampToDateTimeString(updatedAt, $te('common.fullDateFormat') ? $t('common.fullDateFormat') : undefined)
          })}}
        </div>    
        <nav>    
          <ul class="cx-list cx-list--breadcrumb">
            <!-- Home -->
            <li class="cx-list__item">
              <router-link-localed :to="{name: `Home_${$i18n.locale}`}" :aria-label="$t('home.home')"><i class="fal fa-home"></i></router-link-localed>
            </li>
            <!-- Category -->
            <li class="cx-list__item" v-if="categorySetting.name">
              <template v-if="group == '' && entity == ''">{{categorySetting.name}}</template>
              <router-link-localed v-else :to="categorySetting.to">{{categorySetting.name}}</router-link-localed>
            </li>
            <!-- Group -->
            <li class="cx-list__item" v-if="groupSetting.name">
              <template v-if="entity == ''">{{groupSetting.name}}</template>
              <router-link-localed v-else :to="groupSetting.to">{{groupSetting.name}}</router-link-localed>
            </li>
            <!-- Entity -->
            <li class="cx-list__item" v-if="entity != ''">{{entity}}</li>
          </ul>
        </nav>
      </div>
    </div>
  </section>
</template>

<script>
import breadcrumbHelper from '@/mixins/breadcrumbHelper';

export default {
  name: "sight-map-bread-crumb",
  mixins: [breadcrumbHelper],
  props: {
    isArticle: {
      type: Boolean,
      default: false,
    },
    sightMapType: {
      type: String,
      default: "",
    },
    category: {
      type: String,
      default: "",
    },
    group: {
      type: String,
      default: "",
    },
    groupName: {
      type: String,
      default: "",
    },
    entity: {
      type: String,
      default: "",
    },
    updatedAt: {
      type: Number,
      default: 0
    },
    categoryPath: {
      type: String,
      default: null
    }
  },
  uit() {
    return [
      ['enf', ['whatsOn']],
      ['header', ['travelessential']],
      ['home', ['home']],
      ['common', ['updatedAt', 'fullDateFormat']],
      ['trip', ['suggestedTour']],
      ['followTheStar', ['followTheStar']],
      ['mlf', ['name']]
    ]
  },
  computed: {
    warpperClass() {
      return this.isArticle 
        ? ['cx-wrap--page']
        : ['cx-wrap--article', 'm-mapitem__breadcrumb']
    },
    categorySetting() {
      return this.getCategory(
        this.sightMapType,
        this.categoryPath ? this.categoryPath : this.category
      )
    },
    groupSetting() {
      return this.getGroup(
        this.sightMapType,
        this.categoryPath ? this.categoryPath : this.category,
        this.group,
        this.groupName
      );
    }
  }
}
</script>

<style lang="scss">
  .m-update{
    white-space: nowrap;
    margin-bottom: $space-sm;
    @media (min-width: $breakpoint-lg){
      margin-bottom: 0;
      order: 2;
    }
  }
</style>